import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RevolutCheckout, { Mode } from "@revolut/checkout";
import RevolutIcon from "./../../../assets/icons/revolut.svg?react";
import {
  Button,
  Typography,
  Loading,
  AnimatedFormError,
  Input,
  Flex,
} from "djuno-design";
import { userFullnameRegex } from "../../../utils/validations";

const CardDetailsBox: React.FC<
  React.PropsWithChildren<{
    beforInitFn: () => Promise<string | undefined>;
    afterInitFn: (orderToken: string) => Promise<void>;
    initLoading?: boolean;
    savingLoading?: boolean;
    username?: string;
  }>
> = ({ beforInitFn, afterInitFn, initLoading, savingLoading, children }) => {
  // console.log("username:", username);
  const [revolutSetupLoading, setRevolutSetupLoading] = useState(true);
  const [revolutPayLoading, setRevolutPayLoading] = useState(false);
  const [cardHolderName, setCardHolderName] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const cardHolderNameRef = useRef(cardHolderName);

  const handleInitiateRevolut = useCallback(() => {
    const cardFieldTarget = document.getElementById("card-field");
    const buttonTarget = document.getElementById("button-submit");

    //show card details inputs
    if (cardFieldTarget && buttonTarget) {
      try {
        setRevolutSetupLoading(true);
        beforInitFn().then((orderToken) => {
          console.log({ orderToken });
          if (orderToken) {
            const mode =
              (import.meta.env.VITE_REVOLUT_TYPE as Mode) || "sandbox";
            RevolutCheckout(orderToken, mode).then(function (instance) {
              setRevolutSetupLoading(false);
              const cardField = instance.createCardField({
                target: cardFieldTarget,
                name: undefined,
                onSuccess() {
                  setRevolutPayLoading(false);
                  afterInitFn(orderToken);
                },
                onError(error) {
                  setRevolutPayLoading(false);
                  setErrorMessage(`Something went wrong. ${error}`);
                  handleInitiateRevolut();
                },
                styles: {
                  default: {
                    color: "#858585",
                  },
                  autofilled: {
                    color: "#858585",
                  },
                },
              });

              buttonTarget.addEventListener("click", () => {
                // if (cardHolderNameRef.current.match(userFullnameRegex)) {
                setRevolutPayLoading(true);
                cardField.submit({
                  savePaymentMethodFor: "merchant",
                  name: cardHolderNameRef.current,
                });
                // } else {
                //   setErrorMessage(
                //     "Please enter a valid name. It should contain at least 2 words."
                //   );
                // }
              });
            });
          }
        });
      } catch (e) {
        console.log({ e });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleInitiateRevolut();
  }, [handleInitiateRevolut]);

  useEffect(() => {
    cardHolderNameRef.current = cardHolderName;
  }, [cardHolderName]);

  return (
    <>
      <div className="flex flex-col justify-center w-full min-h-[100px] relative">
        {(initLoading || savingLoading) && (
          <div className="flex flex-col justify-center items-center h-full w-full gap-2 absolute inset-0 backdrop-blur-sm z-30">
            <Loading borderSize={2} />
            <Typography.Text className="!text-sm">
              Please wait...
            </Typography.Text>
          </div>
        )}

        <div className="flex items-center w-full text-slate-800 dark:text-slate-200 z-20">
          <Flex direction="col" className="gap-2 w-full">
            <div className="w-full " id="card-field"></div>
            <Input
              placeholder="Card Holder Name"
              id="card-holder-name"
              value={cardHolderName}
              onChange={(e) => setCardHolderName(e.target.value)}
              className="w-full !mt-2"
              // disabled={initLoading || revolutSetupLoading}
              uiType="simple"
            />
          </Flex>
        </div>
        <AnimatedFormError error={errorMessage} />
      </div>
      {children}
      <div className="mt-4 flex justify-between items-center">
        <div className="flex items-center gap-1">
          <Typography.Text className="!text-xs" uiType="secondary">
            Powered by
          </Typography.Text>
          <Typography.Link href="https://revolut.com" target="_blank">
            <RevolutIcon className="h-2.5 text-slate-600 dark:text-slate-400" />
          </Typography.Link>
        </div>
        <Button
          className="w-[40px]"
          uiType="primary"
          id="button-submit"
          loading={
            initLoading ||
            revolutSetupLoading ||
            revolutPayLoading ||
            savingLoading
          }
          disabled={
            initLoading ||
            revolutSetupLoading ||
            revolutPayLoading ||
            savingLoading
          }
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default CardDetailsBox;
